import React from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';

import { Praise, RequestFeedback, ShareFeedback } from 'assets/assetsV1/iconComponents';

import { Button, BUTTON_VARIANT } from 'uiToolkitV1/Button';
import { SplitButton, BUTTON_VARIANT as SPLIT_BUTTON_VARIANT } from 'uiToolkitV1/SplitButton';

import { setSecondaryPanelOpen, setSecondaryScreen } from '../competencyDrawerSlice';
import { SecondaryDrawerScreens } from '../types/slice';

export const FeedbackCTA = () => {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  const location = useLocation();
  const history = useHistory();
  const queryParams = new URLSearchParams(location.search);
  const employeeId = queryParams.get('empId');

  const dispatch = useDispatch();

  const showRequestFeedbackButton = loggedInEmployeeId === employeeId;
  const showShareFeedbackButton = loggedInEmployeeId !== employeeId;

  const openRequestFeedbackPanel = () => {
    dispatch(setSecondaryPanelOpen(true));
    dispatch(setSecondaryScreen(SecondaryDrawerScreens.REQUEST_FEEDBACK));
  };

  const openShareFeedbackPanel = () => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('isSharePublicPraise')) {
      searchParams.delete('isSharePublicPraise');
      history.push({ search: searchParams.toString() });
    }

    dispatch(setSecondaryPanelOpen(true));
    dispatch(setSecondaryScreen(SecondaryDrawerScreens.SHARE_FEEDBACK));
  };

  const openSharePublicPraisePanel = () => {
    const searchParams = new URLSearchParams(location.search);
    if (!searchParams.has('isSharePublicPraise')) {
      searchParams.append('isSharePublicPraise', 'true');
      history.push({ search: searchParams.toString() });
    }

    dispatch(setSecondaryPanelOpen(true));
    dispatch(setSecondaryScreen(SecondaryDrawerScreens.SHARE_FEEDBACK));
  };

  const feedbackMenuOptions = [
    {
      value: 'SHARE_PUBLIC_PRAISE',
      label: `Share public praise`,
      onClick: openSharePublicPraisePanel,
      // eslint-disable-next-line react/no-unstable-nested-components
      icon: () => <Praise fill="transparent" />,
    },
    {
      value: 'SHARE_FEEDBACK',
      label: `Share feedback`,
      onClick: openShareFeedbackPanel,
      icon: ShareFeedback,
    },
  ];

  if (showRequestFeedbackButton) {
    return (
      <Button
        onClick={openRequestFeedbackPanel}
        variant={BUTTON_VARIANT.outlined}
        StartIcon={RequestFeedback}
        startIconProps={{ boxSize: '24px', ml: '-4px !important', mt: '-4px !important' }}
      >
        Request Feedback
      </Button>
    );
  }
  if (showShareFeedbackButton) {
    return (
      <SplitButton
        options={feedbackMenuOptions}
        // eslint-disable-next-line react/no-unstable-nested-components
        StartIcon={() => <Praise fill="transparent" />}
        buttonProps={{
          variant: SPLIT_BUTTON_VARIANT.outlined,
          withBackground: false,
          style: {
            height: '40px',
            padding: '8px 6px 8px 6px',
          },
        }}
        menuButtonProps={{
          withBackground: false,
          style: { height: '40px', padding: '8px' },
        }}
        indexesToRender={undefined}
        menuProps={undefined}
      />
    );
  }

  return null;
};
